module.exports = __webpack_public_path__ + "static/media/tablet_frame.7cd9df65.svg";